module.exports = __webpack_public_path__ + "img/roles-permisos.a5597cd1.svg";